import { AppManager, Variables } from 'core/index';
import { RFQIntermediatorConnectionQuery } from 'apps/rfq/gql';
import { RFQModel } from 'apps/rfq/app';
import { action, observable } from 'mobx';
import type {
  RequestForQuotePage,
  RequestForQuote,
} from 'generated/typescript';

export default class SelectRFQAppManager extends AppManager {
  batchSize = 10;

  rfqsQuery: any = null;

  //   @observable rfqs = [];
  @observable selectedRFQIds: string[] = [];

  @observable rfqModels: RFQModel[] = [];

  navigateShipmentQuoteToIds: (ids: string[]) => void = null;

  constructor(parent: AppManager | null, props: any, options: any) {
    super(parent, props, options);
    this.selectedRFQIds = props.selectedRFQIds;
    this.navigateShipmentQuoteToIds = props.navigateShipmentQuoteToIds;

    const { customerSpaceId } = props;

    const filters: any[] = [];
    if (customerSpaceId) {
      filters.push({
        field: 'customerSpaceID',
        operator: 'EQ',
        values: [
          {
            valueType: 'STRING',
            valueString: customerSpaceId,
          },
        ],
      });
    }

    this.variables = new Variables({
      first: () => this.batchSize,
      offset: () => 0,
      //   sortField: () => null,
      //   sortOrder: () => null,
      filters: (): any[] => filters,
    });

    this.queryRFQs();
  }

  @action ToggleRFQ(rfqId: string) {
    const index = this.selectedRFQIds.indexOf(rfqId);
    if (index === -1) {
      this.selectedRFQIds.push(rfqId);
    } else {
      this.selectedRFQIds.splice(index, 1);
    }
    this.navigateShipmentQuoteToIds(this.selectedRFQIds);
  }

  queryRFQs = () => {
    this.rfqsQuery = new RFQIntermediatorConnectionQuery(this, {
      variables: this.variables,
    });
    this.rfqsQuery.process((rfqs: RequestForQuotePage) => {
      if (rfqs === null) {
        return [];
      }
      return rfqs.nodes.map((rfq: RequestForQuote) => RFQModel.Load(rfq));
    }, this.UpdateRFQs);

    this.rfqsQuery.query();
  };

  @action UpdateRFQs = (rfqModels: RFQModel[]) => {
    this.rfqModels = rfqModels;
    // this.rfqs = rfqModels;
  };
}
